import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { TemplateMethod } from "features/Influencer/ContactList/schema";
import { getSource } from "utils/tracking";
import { useTracking } from "utils/useTracking";

const CreateYourOwn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const source = getSource();
  const { trackVaStep } = useTracking();
  const [method, setMethod] = useState<TemplateMethod | null>(null);

  const handleSubmitMethod = () => {
    if (method === TemplateMethod.use_bento_ai) {
      trackVaStep(routes.templatesBentoAiSelfServeOnboarding, source, true);
      navigate(
        `/${routes.templatesBentoAiSelfServeOnboarding}${location.search}`,
      );
    } else {
      trackVaStep(routes.templatesFromScratchSelfServeOnboarding, source, true);
      navigate(
        `/${routes.templatesFromScratchSelfServeOnboarding}${location.search}`,
      );
    }
  };

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center", mt: 0 }}>
        <Box
          component="i"
          className="fa-regular fa-pen"
          color="secondary.dark"
          sx={{ pr: 1 }}
        />{" "}
        Your First Pitch Template
      </Typography>
      <Typography
        variant="subtitle1"
        gutterBottom
        sx={{ textAlign: "center", mb: 3 }}
      >
        An outreach template helps you reach out to brands by giving you a
        ready-made message. Do you have a template?
      </Typography>

      <Grid container justifyContent="center">
        <FormControl>
          <RadioGroup
            value={method}
            onChange={(e) => setMethod(e.target.value as TemplateMethod)}
          >
            <FormControlLabel
              value={TemplateMethod.from_scratch}
              control={<Radio />}
              label="Yes, I have one I'd like to use"
            />
            <FormControlLabel
              value={TemplateMethod.use_bento_ai}
              control={<Radio />}
              label={"No, use Bento AI to create one 🚀"}
            />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item xs="auto" container columnGap={1} sx={{ mt: 4 }}>
        <Grid item xs="auto"></Grid>
        <Grid item xs></Grid>
        <Grid item xs="auto">
          <Button
            disableElevation
            disabled={!method}
            onClick={handleSubmitMethod}
          >
            Next
            <Box
              sx={{ ml: 1 }}
              component="i"
              className="fa-solid fa-arrow-right"
            />
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default CreateYourOwn;
